import * as _4 from 'lodash4';
import { ConditionalStrategy, Strategy } from 'utility-ts-strategy';
import { APGenericSlot } from '../builders/ap_generic_slot_builder';
import { ap_course_status_type } from './ap_course_status_strategy';
export interface ITermCourseStatusGroup {
  title: string;
  tooltipHtml?: string;
  status?: string[];
  filter: (obj: any) => boolean;
}

export interface ITermGenericSlotStatusGroup extends ITermCourseStatusGroup {
  genericSlots: APGenericSlot[];
  groupKey: string;
}

export const CourseStatusBadgeEvaluator = new ConditionalStrategy({
  in_progress: (status: ap_course_status_type) => 'IN_PROGRESS' === status,
  waitlisted: (status: ap_course_status_type) => 'WAITLISTED' === status,
  ready_to_register: (status: ap_course_status_type) => 'SECTION_PICKED' === status,
  completed: (status: ap_course_status_type) => 'COMPLETED' === status,
  planned: (status: ap_course_status_type) =>
    !_4.includes(['WAITLISTED', 'IN_PROGRESS', 'REGISTERED', 'COMPLETED', 'SECTION_PICKED'], status)
});

export type ap_term_course_status_group_type =
  | 'PLANNED'
  | 'READY_TO_REGISTER'
  | 'REGISTERED'
  | 'IN_PROGRESS'
  | 'COMPLETED'
  | 'WAITLISTED';

export const APTermCourseStatusGroupStrategy = new Strategy<ITermCourseStatusGroup>({
  SECTION_PICKED: {
    title: 'Time Selected (Not Yet Registered)',
    filter: (obj: any) => _4.includes(['SECTION_PICKED'], obj.status)
  },
  PLANNED: {
    title: 'Planned',
    tooltipHtml: 'All planned courses can be dragged to other terms, except locked planned courses',
    filter: (obj: any) =>
      !_4.includes(['WAITLISTED', 'IN_PROGRESS', 'REGISTERED', 'COMPLETED', 'SECTION_PICKED'], obj.status)
  },
  READY_TO_REGISTER: {
    title: 'Ready to Register', // PLANNED and READY TO REGISTER are the same, they have different color and name when registration opens.
    filter: (obj: any) =>
      !_4.includes(['WAITLISTED', 'IN_PROGRESS', 'REGISTERED', 'COMPLETED', 'SECTION_PICKED'], obj.status)
  },
  WAITLISTED: {
    title: 'Waitlisted',
    status: ['WAITLISTED'],
    filter: (obj: any) => obj.status === 'WAITLISTED'
  },
  IN_PROGRESS: {
    title: 'Enrolled/ In Progress',
    status: ['REGISTERED', 'IN_PROGRESS'],
    filter: (obj: any) => obj.status === 'IN_PROGRESS' || obj.status === 'REGISTERED'
  },
  COMPLETED: {
    title: 'Completed',
    status: ['COMPLETED'],
    filter: (obj: any) => obj.status === 'COMPLETED'
  }
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/strategies/ap_term_course_status_group_strategy.ts